const Bitkeep = () => (
    <svg
        version='1.1'
        id='bitkeep'
        xmlns='http://www.w3.org/2000/svg'
        x='0px'
        y='0px'
        viewBox='-10 -30 550 550'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            fill='white'
            d='M469.4,141.4v24.9c0,4.9-2.6,9.4-6.8,11.9l-80.4,46.4l71.7,41.3c9.6,5.5,15.4,15.7,15.4,26.7V359
	c0,11-5.9,21.2-15.5,26.7L265.2,494c-9.5,5.4-21.2,5.4-30.8-0.1l-61.8-35.7c-4.5-2.6-4.5-9.2,0-11.9L376.5,329
	c2.3-1.3,2.3-4.6,0-5.9l-75.7-43.8c-4.2-2.5-9.4-2.5-13.7,0L79.8,398.7c-3.2,1.8-7.1,1.9-10.3,0l-23.4-13.4
	c-9.6-5.5-15.5-15.7-15.5-26.8v-27.2c0-3.7,2-7.1,5.2-8.9l297-170.6c2.3-1.3,2.3-4.6,0-5.9L257,101.9c-4.2-2.5-9.4-2.5-13.7,0
	L40.9,218.3c-4.5,2.6-10.3-0.7-10.3-5.9V141c0-11,5.9-21.2,15.5-26.7L234.8,6c9.5-5.4,21.2-5.4,30.7,0l188.3,108.6
	C463.4,120.2,469.4,130.3,469.4,141.4z'
        />
    </svg>
);

export default Bitkeep;
